import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

export function ModalAlert({ errorGet = false, msgHead, msgBody }) {
  /*Doc html-react-parser: https://www.npmjs.com/package/html-react-parser */
  const parse = require('html-react-parser');
  const [show, setShow] = useState(errorGet);
  const [showMsgH, setShowMsgH] = useState("");
  const [showMsgB, setShowMsgB] = useState("");

  useEffect(() => {
    if (errorGet) {
      setShow(errorGet);
      setShowMsgH(msgHead);
      setShowMsgB(msgBody);
    }
  }, [errorGet, msgHead, msgBody]);

  function handleClose() {
    setShow(false);
    setShowMsgB("");
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} contentClassName="font-family">
        <Modal.Header closeButton>
          <Modal.Title>{showMsgH}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: "center" }}>{parse(showMsgB)}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default ModalAlert;
